import { useDispatch } from 'react-redux';
import { usePanels } from '../../../panels/usePanels';
import { useConfigurationCanvas } from '../../configuration-canvas/public/useConfigurationCanvas';
import { useCallback } from 'react';
import SweepStagesModel from '../../../../models/stagesModel';
import { stagePanelType } from '../../funnel-map-flow/dialogs/stage/panelType';
import { closeStageDialog, openStageDialog } from '../../../../reducers/funnel-flow-page/stageDialogReducer';
import { StageDialogTabTypes } from '../../../../types/enums/StageDialogTabTypes';

const useOpenStepDialog = () => {
  const dispatch = useDispatch();
  const { maybeOpenPanel } = usePanels();
  const { canvasFunnelMap } = useConfigurationCanvas();

  const openStepDialog = useCallback(
    ({ stepId, funnelId }: { stepId: string; funnelId: string }) => {
      const funnelDetails = canvasFunnelMap.funnelsData[funnelId]?.funnelDetails;
      const stagesModel = new SweepStagesModel(funnelDetails?.stages || []);
      const stage = stagesModel.stageByIdOrUndefined(stepId)?.getStage();

      if (stage) {
        maybeOpenPanel({
          panelType: stagePanelType,
          instanceId: stage._stageId,
          onOpen: () => {
            dispatch(
              openStageDialog({
                stageId: stage._stageId,
                activeTab: StageDialogTabTypes.GATES,
                funnelId: funnelId,
              }),
            );
          },
          onClose: () => {
            dispatch(closeStageDialog());
          },
        });
      }
    },
    [canvasFunnelMap.funnelsData, dispatch, maybeOpenPanel],
  );
  return {
    openStepDialog,
  };
};

export default useOpenStepDialog;
